import { MenuDesignTokens } from '@primeuix/themes/types/menu';

export const MENU_ITEM_STYLES: MenuDesignTokens = {
  submenuLabel: {
    padding: '0.1rem 0.75rem',
  },
  css: ({ dt }) => `
.text-red-500 .p-menu-item-content {
  color: ${dt('red.500')} !important;
}

.actions-menu .p-menuitem-link {
  padding: 0.5rem 0.5rem;
}

.actions-menu .p-menu-list {
  padding: 0.5rem 0.5rem;
  gap: 0.5rem;
}
`,
};
